// extracted by mini-css-extract-plugin
module.exports = {"flat":"_view_flat__QBH9l","smooth":"_view_smooth__1LYL-","raised":"_view_raised__3SCFL"};